// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3szy3","name":"ConsentHeader_name__wESc3","birthday":"ConsentHeader_birthday__25p9_","skeleton":"ConsentHeader_skeleton__12R7K"};